<script lang="ts">
  import { items as apiSidebarItems } from "$lib/../../generated/pydoc/sidebar.json";
  import SideSection from "$lib/ui/docs/SideSection.svelte";
  import ThreeColumn from "$lib/ui/docs/ThreeColumn.svelte";

  const cliSidebarItems = Object.keys(
    import.meta.glob("$lib/../../generated/cli/*.md"),
  ).map((x) => x.match(/(\w+)(?:.md)/)![1]);

  const changelogSection = {
    title: "Changelog",
    href: "/docs/reference/changelog",
  };

  const apiSection = {
    title: "API Reference",
    pages: apiSidebarItems.map((item) => ({
      title: item.label,
      href: `/docs/reference/${item.label}`,
    })),
  };

  const cliSection = {
    title: "CLI Reference",
    pages: cliSidebarItems.map((item) => ({
      title: `modal ${item}`,
      href: `/docs/reference/cli/${item}`,
    })),
  };
</script>

<ThreeColumn>
  <svelte:fragment slot="sidebar-links">
    <SideSection section={changelogSection} />
    <SideSection section={apiSection} dumbHeader monoItems />
    <SideSection section={cliSection} dumbHeader monoItems />
  </svelte:fragment>

  <slot />
</ThreeColumn>
